<template>
    <va-create-layout>
        <CogCatalogItemTransaction-form
            :title="title"
            :item="item"
        ></CogCatalogItemTransaction-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
